var map = {
	"./Foreign Aid Icon.png": 1405,
	"./Genesis_Planet_Token.png": 5221,
	"./Lunar_Cannon_Token.png": 7200,
	"./Prometheus_Token.png": 8523,
	"./alien icons/avatar_AI.png": 7884,
	"./alien icons/avatar_Ace.png": 143,
	"./alien icons/avatar_Alchemist.png": 1023,
	"./alien icons/avatar_Alien.png": 5220,
	"./alien icons/avatar_Amoeba.png": 374,
	"./alien icons/avatar_Anarchist.png": 4560,
	"./alien icons/avatar_Angler.png": 7017,
	"./alien icons/avatar_Animal.png": 1671,
	"./alien icons/avatar_Anti-Matter.png": 3065,
	"./alien icons/avatar_Arcade.png": 2123,
	"./alien icons/avatar_Architect.png": 2601,
	"./alien icons/avatar_Aristocrat.png": 6109,
	"./alien icons/avatar_Assessor.png": 2670,
	"./alien icons/avatar_Assistant.png": 9566,
	"./alien icons/avatar_Aura.png": 5331,
	"./alien icons/avatar_Bandit.png": 1222,
	"./alien icons/avatar_Barbarian.png": 2974,
	"./alien icons/avatar_Bleeding_Heart.png": 2843,
	"./alien icons/avatar_Boomerang.png": 2572,
	"./alien icons/avatar_Booster.png": 1552,
	"./alien icons/avatar_Bride.png": 3896,
	"./alien icons/avatar_Brute.png": 5564,
	"./alien icons/avatar_Brute_AT.png": 8435,
	"./alien icons/avatar_Bubble.png": 8196,
	"./alien icons/avatar_Bully.png": 6857,
	"./alien icons/avatar_Bulwark.png": 8732,
	"./alien icons/avatar_Butler.png": 989,
	"./alien icons/avatar_Calculator.png": 9238,
	"./alien icons/avatar_Cavalry.png": 7883,
	"./alien icons/avatar_Changeling.png": 8570,
	"./alien icons/avatar_Chosen.png": 4278,
	"./alien icons/avatar_Chronos.png": 7193,
	"./alien icons/avatar_Chrysalis.png": 5019,
	"./alien icons/avatar_Citadel.png": 7347,
	"./alien icons/avatar_Claw.png": 9985,
	"./alien icons/avatar_Cloak.png": 4385,
	"./alien icons/avatar_Clone.png": 7195,
	"./alien icons/avatar_Converter.png": 1619,
	"./alien icons/avatar_Coordinator.png": 1553,
	"./alien icons/avatar_Cosmos.png": 1017,
	"./alien icons/avatar_Coward.png": 1650,
	"./alien icons/avatar_Crusher.png": 8692,
	"./alien icons/avatar_Cryo.png": 1000,
	"./alien icons/avatar_Crystal.png": 241,
	"./alien icons/avatar_Cudgel.png": 3801,
	"./alien icons/avatar_Cult.png": 1762,
	"./alien icons/avatar_Cyborg.png": 5492,
	"./alien icons/avatar_Daredevil.png": 1979,
	"./alien icons/avatar_Daredevil_AT.png": 1003,
	"./alien icons/avatar_Decoy.png": 4612,
	"./alien icons/avatar_Delegator.png": 1391,
	"./alien icons/avatar_Demon.png": 5161,
	"./alien icons/avatar_Demon_AT.png": 1948,
	"./alien icons/avatar_Dervish.png": 1803,
	"./alien icons/avatar_Deuce.png": 3046,
	"./alien icons/avatar_Dictator.png": 9152,
	"./alien icons/avatar_Diplomat.png": 1656,
	"./alien icons/avatar_Disease.png": 9830,
	"./alien icons/avatar_Doppelganger.png": 8352,
	"./alien icons/avatar_Dragon.png": 5189,
	"./alien icons/avatar_Empath.png": 7381,
	"./alien icons/avatar_Emperor.png": 4762,
	"./alien icons/avatar_Engineer.png": 3305,
	"./alien icons/avatar_Ethic.png": 514,
	"./alien icons/avatar_Evil_Twin.png": 2339,
	"./alien icons/avatar_Explorer.png": 2293,
	"./alien icons/avatar_Extortionist.png": 9897,
	"./alien icons/avatar_Extractor.png": 2729,
	"./alien icons/avatar_Fido.png": 7454,
	"./alien icons/avatar_Filch.png": 7054,
	"./alien icons/avatar_Filth.png": 1346,
	"./alien icons/avatar_Fire_Dancer.png": 8283,
	"./alien icons/avatar_Fodder.png": 8828,
	"./alien icons/avatar_Force.png": 8099,
	"./alien icons/avatar_Fungus.png": 8322,
	"./alien icons/avatar_Fury.png": 9853,
	"./alien icons/avatar_Gambler.png": 2306,
	"./alien icons/avatar_Geek.png": 1455,
	"./alien icons/avatar_General.png": 928,
	"./alien icons/avatar_Genius.png": 9145,
	"./alien icons/avatar_Ghoul.png": 1384,
	"./alien icons/avatar_Glutton.png": 9675,
	"./alien icons/avatar_Gorgon.png": 9864,
	"./alien icons/avatar_Graviton.png": 4859,
	"./alien icons/avatar_Greenhorn.png": 6611,
	"./alien icons/avatar_Gremlin.png": 7503,
	"./alien icons/avatar_Grudge.png": 2047,
	"./alien icons/avatar_Grumpus.png": 6071,
	"./alien icons/avatar_Grumpus_AT.png": 2955,
	"./alien icons/avatar_Guardian.png": 1385,
	"./alien icons/avatar_Guerrilla.png": 7561,
	"./alien icons/avatar_Hacker.png": 4071,
	"./alien icons/avatar_Hate.png": 5685,
	"./alien icons/avatar_Healer.png": 126,
	"./alien icons/avatar_Horde.png": 9230,
	"./alien icons/avatar_Host.png": 1726,
	"./alien icons/avatar_Human.png": 9964,
	"./alien icons/avatar_Hunger.png": 5574,
	"./alien icons/avatar_Hurtz.png": 8888,
	"./alien icons/avatar_Hypochondriac.png": 1602,
	"./alien icons/avatar_Industrialist.png": 6016,
	"./alien icons/avatar_Inferno.png": 38,
	"./alien icons/avatar_Insect.png": 8923,
	"./alien icons/avatar_Invader.png": 3007,
	"./alien icons/avatar_Joker.png": 2824,
	"./alien icons/avatar_Judge.png": 1024,
	"./alien icons/avatar_Kamikaze.png": 5899,
	"./alien icons/avatar_Klutz.png": 8118,
	"./alien icons/avatar_Laser.png": 4668,
	"./alien icons/avatar_Lemming.png": 8853,
	"./alien icons/avatar_Leviathan.png": 2332,
	"./alien icons/avatar_Lightning.png": 7072,
	"./alien icons/avatar_Lizard.png": 7738,
	"./alien icons/avatar_Lloyd.png": 6803,
	"./alien icons/avatar_Locust.png": 4396,
	"./alien icons/avatar_Locust_AT.png": 5005,
	"./alien icons/avatar_Loser.png": 6062,
	"./alien icons/avatar_Love.png": 7665,
	"./alien icons/avatar_Lunatic.png": 240,
	"./alien icons/avatar_Machine.png": 5274,
	"./alien icons/avatar_Macron.png": 8400,
	"./alien icons/avatar_Magician.png": 2797,
	"./alien icons/avatar_Magnet.png": 5594,
	"./alien icons/avatar_Masochist.png": 2909,
	"./alien icons/avatar_Masochist_AT.png": 8155,
	"./alien icons/avatar_Maven.png": 915,
	"./alien icons/avatar_Meek.png": 3550,
	"./alien icons/avatar_Mercenary.png": 1374,
	"./alien icons/avatar_Merchant.png": 3612,
	"./alien icons/avatar_Mesmer.png": 6844,
	"./alien icons/avatar_Micron_AT.png": 5262,
	"./alien icons/avatar_Mimic.png": 333,
	"./alien icons/avatar_Mind.png": 7259,
	"./alien icons/avatar_Mirage.png": 9889,
	"./alien icons/avatar_Mirror.png": 4523,
	"./alien icons/avatar_Miser.png": 5293,
	"./alien icons/avatar_Mite.png": 7745,
	"./alien icons/avatar_Moocher.png": 4393,
	"./alien icons/avatar_Mouth.png": 5770,
	"./alien icons/avatar_Muckraker.png": 5365,
	"./alien icons/avatar_Multitude.png": 1932,
	"./alien icons/avatar_Mutant.png": 3750,
	"./alien icons/avatar_Nanny.png": 6976,
	"./alien icons/avatar_Negator.png": 8615,
	"./alien icons/avatar_Neighbor.png": 6429,
	"./alien icons/avatar_Nightmare.png": 977,
	"./alien icons/avatar_Observer.png": 6349,
	"./alien icons/avatar_Oligarch.png": 2474,
	"./alien icons/avatar_Oracle.png": 3313,
	"./alien icons/avatar_Outlaw.png": 7298,
	"./alien icons/avatar_Pacifist.png": 8296,
	"./alien icons/avatar_Pack_Rat.png": 2284,
	"./alien icons/avatar_Parasite.png": 8623,
	"./alien icons/avatar_Particle.png": 1331,
	"./alien icons/avatar_Patriot.png": 988,
	"./alien icons/avatar_Peddler.png": 226,
	"./alien icons/avatar_Pentaform.png": 9474,
	"./alien icons/avatar_Perfectionist.png": 9670,
	"./alien icons/avatar_Perfectionist_AT.png": 1032,
	"./alien icons/avatar_Phantasm.png": 7097,
	"./alien icons/avatar_Phantom.png": 9079,
	"./alien icons/avatar_Philanthropist.png": 2288,
	"./alien icons/avatar_Pickpocket.png": 3308,
	"./alien icons/avatar_Pirate.png": 2434,
	"./alien icons/avatar_Plant.png": 1482,
	"./alien icons/avatar_Poison.png": 8729,
	"./alien icons/avatar_Porcupine.png": 2811,
	"./alien icons/avatar_Pretender.png": 5134,
	"./alien icons/avatar_Prophet.png": 5015,
	"./alien icons/avatar_Pygmy.png": 5003,
	"./alien icons/avatar_Quartermaster.png": 870,
	"./alien icons/avatar_Reactor.png": 5585,
	"./alien icons/avatar_Reborn.png": 3042,
	"./alien icons/avatar_Reincarnator.png": 446,
	"./alien icons/avatar_Relic.png": 7276,
	"./alien icons/avatar_Remora.png": 656,
	"./alien icons/avatar_Remote.png": 7107,
	"./alien icons/avatar_Reserve.png": 8159,
	"./alien icons/avatar_Roach.png": 9164,
	"./alien icons/avatar_Saboteur.png": 6360,
	"./alien icons/avatar_Sadist.png": 9325,
	"./alien icons/avatar_Sadist_AT.png": 9439,
	"./alien icons/avatar_Sapient.png": 5886,
	"./alien icons/avatar_Scavenger.png": 2978,
	"./alien icons/avatar_Schizoid.png": 3519,
	"./alien icons/avatar_Schizoid_AT.png": 1763,
	"./alien icons/avatar_Seeker.png": 1142,
	"./alien icons/avatar_Shadow.png": 8847,
	"./alien icons/avatar_Sheriff.png": 6299,
	"./alien icons/avatar_Silencer.png": 6940,
	"./alien icons/avatar_Siren.png": 8738,
	"./alien icons/avatar_Skeptic.png": 2790,
	"./alien icons/avatar_Sloth.png": 3073,
	"./alien icons/avatar_Sneak.png": 3623,
	"./alien icons/avatar_Sniveler.png": 7497,
	"./alien icons/avatar_Sorcerer.png": 3131,
	"./alien icons/avatar_Sorcerer_long.png": 9393,
	"./alien icons/avatar_Spiff.png": 2290,
	"./alien icons/avatar_Squee.png": 5394,
	"./alien icons/avatar_Sting.png": 3833,
	"./alien icons/avatar_Surgeon.png": 1041,
	"./alien icons/avatar_Swindler.png": 1285,
	"./alien icons/avatar_Sycophant.png": 763,
	"./alien icons/avatar_Symbiote.png": 270,
	"./alien icons/avatar_Tentacle.png": 6475,
	"./alien icons/avatar_Throwback.png": 3895,
	"./alien icons/avatar_Tick-Tock.png": 8947,
	"./alien icons/avatar_Tide.png": 445,
	"./alien icons/avatar_Tortoise.png": 1854,
	"./alien icons/avatar_Tourist.png": 7178,
	"./alien icons/avatar_Trader.png": 4862,
	"./alien icons/avatar_Trickster.png": 6667,
	"./alien icons/avatar_Tripler.png": 6293,
	"./alien icons/avatar_Tyrant.png": 1371,
	"./alien icons/avatar_Usurper.png": 5602,
	"./alien icons/avatar_Vacuum.png": 2218,
	"./alien icons/avatar_Vector.png": 7913,
	"./alien icons/avatar_Virus.png": 6257,
	"./alien icons/avatar_Visionary.png": 8461,
	"./alien icons/avatar_Void.png": 9171,
	"./alien icons/avatar_Void_AT.png": 3796,
	"./alien icons/avatar_Vox.png": 5678,
	"./alien icons/avatar_Voyager.png": 472,
	"./alien icons/avatar_Vulch.png": 2195,
	"./alien icons/avatar_Warhawk.png": 3442,
	"./alien icons/avatar_Warpish.png": 5626,
	"./alien icons/avatar_Warrior.png": 8265,
	"./alien icons/avatar_Whirligig.png": 7704,
	"./alien icons/avatar_Will.png": 8166,
	"./alien icons/avatar_Winner.png": 810,
	"./alien icons/avatar_Witch.png": 7648,
	"./alien icons/avatar_Worm.png": 2508,
	"./alien icons/avatar_Wormhole.png": 7281,
	"./alien icons/avatar_Wrack.png": 4790,
	"./alien icons/avatar_Xenophile.png": 3363,
	"./alien icons/avatar_Yin-Yang.png": 3859,
	"./alien icons/avatar_Zilch.png": 9890,
	"./alien icons/avatar_Zombie.png": 190,
	"./alien icons/avatar_Zombie_AT.png": 111,
	"./envoy icons/avatar_Bouncer.png": 8748,
	"./envoy icons/avatar_Cheater.png": 1601,
	"./envoy icons/avatar_Crabby.png": 8282,
	"./envoy icons/avatar_Duelist.png": 645,
	"./envoy icons/avatar_Friend.png": 3838,
	"./envoy icons/avatar_Hybrid.png": 5299,
	"./envoy icons/avatar_Intelligent_Mineral.png": 8455,
	"./envoy icons/avatar_Iron_Matron.png": 3107,
	"./envoy icons/avatar_Knot.png": 8066,
	"./envoy icons/avatar_Musician.png": 4289,
	"./envoy icons/avatar_Pickled.png": 131,
	"./envoy icons/avatar_Pitfall.png": 4246,
	"./envoy icons/avatar_Politician.png": 843,
	"./envoy icons/avatar_Preservationist.png": 7341,
	"./envoy icons/avatar_Prime.png": 5344,
	"./envoy icons/avatar_Recoiler.png": 9366,
	"./envoy icons/avatar_Red_Tape.png": 4776,
	"./envoy icons/avatar_Roller.png": 3756,
	"./envoy icons/avatar_Sponge.png": 2630,
	"./envoy icons/avatar_Spy.png": 176,
	"./envoy icons/avatar_Swarm.png": 756,
	"./envoy icons/avatar_Tactician.png": 7461,
	"./envoy icons/avatar_Uber_Reserve.png": 7809,
	"./envoy icons/avatar_Ubiquitous.png": 5449,
	"./envoy icons/avatar_Underdog.png": 9087,
	"./envoy icons/avatar_Unseen.png": 6306,
	"./envoy icons/avatar_Worry_Wart.png": 5320,
	"./goback.gif": 1072,
	"./gridwallpaper.jpg": 4686,
	"./station icons/Alien_Outpost.png": 8516,
	"./station icons/Artifact_Detection_Grid.png": 9422,
	"./station icons/Big_Sky_Laser.png": 6663,
	"./station icons/Big_Space_Laser.png": 5281,
	"./station icons/Burst_Targeter.png": 7689,
	"./station icons/Colony_Cloak.png": 789,
	"./station icons/Cosmic_Energy_Generator.png": 9193,
	"./station icons/Exhortation.png": 7926,
	"./station icons/Fluxx_Capacitor.png": 9680,
	"./station icons/Freewheeling_Intensifier.png": 1992,
	"./station icons/Golden_City.png": 3876,
	"./station icons/Hand_Additor.png": 9491,
	"./station icons/High-Activity_Staging_Zone.png": 3837,
	"./station icons/Hyperspace_Redirect.png": 5624,
	"./station icons/Icy_Optimization.png": 5553,
	"./station icons/Massive_Battery.png": 9542,
	"./station icons/Obligatron.png": 6521,
	"./station icons/Observation_Platform.png": 5541,
	"./station icons/Observation_Platform_2.png": 5535,
	"./station icons/Option_Cycler.png": 3714,
	"./station icons/Orbital_Billboards.png": 9799,
	"./station icons/Oscillation_Overthruster.png": 9683,
	"./station icons/Population_Monitor.png": 981,
	"./station icons/Quark_Refinery.png": 6057,
	"./station icons/Recycler.png": 6051,
	"./station icons/Rift_Enacter.png": 4208,
	"./station icons/Shield_Generator.png": 168,
	"./station icons/Shock_Trooper_Shuttle_Pods.png": 394,
	"./station icons/Stun_Apparatus.png": 5135,
	"./station icons/Tactical_Array.png": 5543,
	"./station icons/Targeting_Depot.png": 3978,
	"./station icons/Temporal_Matrix.png": 8430,
	"./station icons/Transdimensional_Rift_Relay.png": 1587,
	"./station icons/Warp_Harvester.png": 6876,
	"./station icons/Zap_Zapper.png": 8294,
	"./station icons/Zaptimizer.png": 9571,
	"./variant icons/4 Planets Icon.png": 8549,
	"./variant icons/Age Icon.png": 9305,
	"./variant icons/Alliance Icon.png": 5316,
	"./variant icons/Anomalies Icon.png": 3478,
	"./variant icons/Campaign Icon 2.png": 9391,
	"./variant icons/Common Icon.png": 2568,
	"./variant icons/Contract Icon.png": 7742,
	"./variant icons/Dial Icon.png": 7741,
	"./variant icons/Envoy Icon.png": 1628,
	"./variant icons/Evolution Icon.png": 4935,
	"./variant icons/Foreign Aid Icon.png": 3840,
	"./variant icons/Freewheeling Icon.png": 5754,
	"./variant icons/Hand Draft Icon.png": 7034,
	"./variant icons/Hazard Icon.png": 6421,
	"./variant icons/Influencers Icon.png": 4438,
	"./variant icons/Lux Icon.png": 7165,
	"./variant icons/Master Card Icon.png": 7623,
	"./variant icons/Moon Icon.png": 9958,
	"./variant icons/Objectives Icon.png": 9115,
	"./variant icons/Privilege Icon.png": 8162,
	"./variant icons/Rewards Icon.png": 2025,
	"./variant icons/Special Ship Icon 2.png": 4467,
	"./variant icons/Special Ship Icon.png": 2640,
	"./variant icons/Stations Icon.png": 8509,
	"./variant icons/Super Shots Icon.png": 6651,
	"./variant icons/Tech Icon.png": 7287,
	"./variant icons/Win Limit Icon.png": 3439,
	"./variant icons/Wrench Icon.png": 3385,
	"./warplogo.jpg": 8021,
	"./warplogo2.jpg": 7191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;